import React from 'react'
import { Tag, TagLabel } from '@chakra-ui/react'
import { PracticeManagementSystem } from '~graphql/generated/graphql'

interface Props {
    pms: PracticeManagementSystem
}

export default function PmsTag({ pms }: Props) {
    return (
        <Tag
            colorScheme={pmsColors[pms] || 'gray'}
            size="sm"
            px={3}
            rounded="full"
        >
            <TagLabel textTransform="uppercase">{pms}</TagLabel>
        </Tag>
    )
}

const pmsColors: Partial<Record<PracticeManagementSystem, string>> = {
    [PracticeManagementSystem.AvImark]: 'red',
    [PracticeManagementSystem.BwAvimark]: 'red',
    [PracticeManagementSystem.Cornerstone]: 'originalPink',
    [PracticeManagementSystem.Daysmart]: 'cyan',
    [PracticeManagementSystem.EzyVet]: 'teal',
    [PracticeManagementSystem.Instinct]: 'purple',
    [PracticeManagementSystem.ImpromedInfinity]: 'yellow',
    [PracticeManagementSystem.Provet]: 'originalPurple',
    [PracticeManagementSystem.Pulse]: 'green',
    [PracticeManagementSystem.Rhapsody]: 'orange',
    [PracticeManagementSystem.Shepherd]: 'originalBlue',
}
